import afmsApiInstance from "afms/api";

const BASE = "/vendor-command-center";

const CommandCenterApiService = {
  getOverview: (params, config) => afmsApiInstance.get(`${BASE}/overview`, { params, ...config }),

  getKpis: (params, config) => afmsApiInstance.get(`${BASE}/kpis`, { params, ...config }),

  getPickupRequests: (params, config) => afmsApiInstance.get(`${BASE}/pickup-requests`, { params, ...config }),

  getRouteSummary: (params, config) => afmsApiInstance.get(`${BASE}/routes/summary`, { params, ...config }),

  getRouteMap: (routeId, config) => afmsApiInstance.get(`${BASE}/routes/${routeId}/map`, { ...config }),

  getTimeline: (params, config) => afmsApiInstance.get(`${BASE}/timeline`, { params, ...config }),

  getFleet: (config) => afmsApiInstance.get(`${BASE}/fleet`, { ...config }),

  getMaterialMix: (params, config) => afmsApiInstance.get(`${BASE}/material-mix`, { params, ...config }),
};

export default CommandCenterApiService;
